/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOneAddIndex,
  setAddedIndexesCumulatativeToggle,
  setAddedIndexesInit,
  setAddedIndexesId,
  setAddedIndexesName,
  setAddedIndexesPeriodOfTime,
  setAddedIndexesSpatialStat,
  setAddedIndexesStat,
  setAddedIndexesTempStat,
  setAddedIndexesTemporalMethod,
  setAddedIndexesYearFrom,
  setAddedIndexesYearTo,
  setAddedIndexesdayFrom,
  setAddedIndexesdayTo,
  setAddedIndexesmonthFrom,
  setAddedIndexesmonthTo,
  setMainIndex,
  setMainPeriodOfTime,
  setMainTemporalMethod,
  setSelectByMonth,
  setSelectByMonthInit,
  setSelectedDayFrom,
  setSelectedDayTo,
  setSelectedMainInit,
  setSelectedMonthFrom,
  setSelectedMonthTo,
  setSelectedYearFrom,
  setSelectedYearTo,
  setSpatialStats,
  setTemporalStats,
  setmainCumulatativeToggle,
  setmainDateRangeInit,
  setmainIndexLoadingInit,
  setmainIndexPathsInit,
  setCurrentAll,
  setSelectedYearFromCurrent,
  setSelectedYearToCurrent,
} from "../../reducers/PredictionSlice";
import {
  Autocomplete,
  TextField,
  Typography,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Divider,
  Popover,
} from "@mui/material";
import "./style.css";
import { setStatSelect } from "../../reducers/PredictionSlice";
import MonthDayRangePicker from "./MonthDayRangePicker";
import CustomYearsPicker from "./CustomYearPicker";
import MonthDayRangePickerByIndex from "./MonthDayRangePickerByIndex";
import CustomYearsPickerByIndex from "./CustomYearPickerByIndex";
import CustomCheckBox from "../Masking/CustomCheckBox";
import { DateRangePicker } from 'react-date-range'; // Import react-date-range
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import YearPickerPrediction from "../Masking/YearPickerPrediction";

const requiredFieldStyle = {
  '& label': {
    '&::after': {
      content: '" *"',
      color: 'red',
    }
  }
};

const MainIndex = ({ indexes, showValidation = false }) => {
  const dispatch = useDispatch();
  const mainIndex = useSelector((state) => state.predictionState.mainIndex);
  const mainTemporalMethod = useSelector(
    (state) => state.predictionState.mainTemporalMethod
  );

  const addIndexes = useSelector((state) => state.predictionState.addedIndexes);
  const monthFrom = useSelector(
    (state) => state.predictionState.selectedMonthFrom
  );
  const monthTo = useSelector((state) => state.predictionState.selectedMonthTo);
  const dayFrom = useSelector((state) => state.predictionState.selectedDayFrom);
  const dayTo = useSelector((state) => state.predictionState.selectedDayTo);
  const yearFrom = useSelector(
    (state) => state.predictionState.selectedYearFrom
  );
  const yearTo = useSelector((state) => state.predictionState.selectedYearTo);
  const mainPeriodOfTime = useSelector(
    (state) => state.predictionState.mainPeriodOfTime
  );
  const currentAll = useSelector((state) => state.predictionState.currentAll);
  const defHistYearFrom = currentAll[0]?.hist_yearFrom;
  const defHistYearTo = currentAll[0]?.hist_yearTo;

  const spatialStats = useSelector((state) => state.predictionState.spatialStats);
  const temporalStats = useSelector((state) => state.predictionState.temporalStats);

  const [mainPickerAnchorEl, setMainPickerAnchorEl] = useState(null);
  const mainPickerOpen = Boolean(mainPickerAnchorEl);
  const mainPickerId = mainPickerOpen ? 'main-daterange-popover' : undefined;

  // Track touched fields
  const [touchedFields, setTouchedFields] = useState({
    dateRange: false,
    spatialStats: false,
    temporalStats: false,
    histYearFrom: false,
    histYearTo: false,
  });

  // --- State for Added Index Pickers --- 
  const [addedPickerAnchorEls, setAddedPickerAnchorEls] = useState({});
  const [addedTouchedFields, setAddedTouchedFields] = useState({});


  const handleAddIndex = () => {
    if (addIndexes.length > 0) {
      // Get the first index's data
      const firstIndex = addIndexes[0];

      // Initialize new index
      dispatch(setAddedIndexesInit());

      // Get the new index number
      const newIndex = addIndexes.length;

      // Copy all data from first index
      if (firstIndex.id && firstIndex.name) {
        dispatch(setAddedIndexesId({ index: newIndex, id: firstIndex.id }));
        dispatch(setAddedIndexesName({ index: newIndex, name: firstIndex.name }));
      }

      // Copy date ranges
      if (firstIndex.current_yearFrom) {
        dispatch(setAddedIndexesYearFrom({ index: newIndex, yearFrom: firstIndex.current_yearFrom }));
      }
      if (firstIndex.current_yearTo) {
        dispatch(setAddedIndexesYearTo({ index: newIndex, yearTo: firstIndex.current_yearTo }));
      }
      if (firstIndex.current_monthFrom) {
        dispatch(setAddedIndexesmonthFrom({ index: newIndex, monthFrom: firstIndex.current_monthFrom }));
      }
      if (firstIndex.current_monthTo) {
        dispatch(setAddedIndexesmonthTo({ index: newIndex, monthTo: firstIndex.current_monthTo }));
      }
      if (firstIndex.current_dayFrom) {
        dispatch(setAddedIndexesdayFrom({ index: newIndex, dayFrom: firstIndex.current_dayFrom }));
      }
      if (firstIndex.current_dayTo) {
        dispatch(setAddedIndexesdayTo({ index: newIndex, dayTo: firstIndex.current_dayTo }));
      }

      // Copy stats
      if (firstIndex.spatialStats) {
        dispatch(setAddedIndexesSpatialStat({
          index: newIndex,
          stat: firstIndex.spatialStats
        }));
      } else if (spatialStats && mainIndex[0]) {
        // Copy from main index if first index doesn't have stats
        dispatch(setAddedIndexesSpatialStat({
          index: newIndex,
          stat: spatialStats[mainIndex[0]] || ''
        }));
      }

      if (firstIndex.temporalStats) {
        dispatch(setAddedIndexesTempStat({
          index: newIndex,
          stat: firstIndex.temporalStats
        }));
      } else if (temporalStats && mainIndex[0]) {
        // Copy from main index if first index doesn't have stats
        dispatch(setAddedIndexesTempStat({
          index: newIndex,
          stat: temporalStats[mainIndex[0]] || ''
        }));
      }

      // Copy methods and period
      if (firstIndex.temporalMethod) {
        dispatch(setAddedIndexesTemporalMethod({
          index: newIndex,
          index2: newIndex,
          temporalMethod: firstIndex.temporalMethod
        }));
      }
      if (firstIndex.periodOfTime) {
        dispatch(setAddedIndexesPeriodOfTime({
          index: newIndex,
          index2: newIndex,
          periodOfTime: firstIndex.periodOfTime
        }));
      }
    } else {
      dispatch(setAddedIndexesInit());
    }
  };

  const statsList = [
    { name: "Mean", key: "mean" },
    { name: "Min", key: "min" },
    { name: "Max", key: "max" },
    { name: "Median", key: "median" },
    { name: "Sum", key: "sum" },
    { name: "STD", key: "std" },
  ];

  const getDateRange = (index) => {
    if (!index) return [];
    try {
      const categories = JSON.parse(localStorage.getItem("categories")) || [];
      const currentIndex = categories.find((category) => category.name.toLowerCase() === index.toLowerCase());
      if (currentIndex && currentIndex.available_from && currentIndex.available_to) {
        return [new Date(currentIndex.available_from), new Date(currentIndex.available_to)];
      }
    } catch (error) {
      console.error("Error parsing categories from localStorage:", error);
    }
    return [];
  }

  // --- Helper function to format state for react-date-range ---
  const formatRangeForPicker = (yF, mF, dF, yT, mT, dT, indexName = null) => {
    const yearFrom = parseInt(yF, 10);
    const monthFrom = parseInt(mF, 10) - 1; // Month is 0-indexed
    const dayFrom = parseInt(dF, 10);
    const yearTo = parseInt(yT, 10);
    const monthTo = parseInt(mT, 10) - 1; // Month is 0-indexed
    const dayTo = parseInt(dT, 10);

    let startDate, endDate;

    // Check if we have valid selected dates
    const hasValidStartDate = !isNaN(yearFrom) && !isNaN(monthFrom) && !isNaN(dayFrom);
    const hasValidEndDate = !isNaN(yearTo) && !isNaN(monthTo) && !isNaN(dayTo);

    if (hasValidStartDate && hasValidEndDate) {
      // Use selected dates
      startDate = new Date(yearFrom, monthFrom, dayFrom);
      endDate = new Date(yearTo, monthTo, dayTo);
    } else {
      // No dates selected, use the available range for the index
      const availableRange = getDateRange(indexName || (mainIndex && mainIndex[0]));
      if (availableRange.length === 2) {
        startDate = availableRange[1]; // Use the last available date
        endDate = availableRange[1];   // Set both to last date initially
      } else {
        // Fallback to current date if no range available
        const currentDate = new Date();
        startDate = currentDate;
        endDate = currentDate;
      }
    }

    return [{
        startDate: startDate,
        endDate: endDate,
        key: 'selection'
    }];
  };

  const handleRangeChange = (item, isMainIndex, index = null) => {
    const selectionKey = Object.keys(item)[0];
    const range = item[selectionKey];

    if (!range || !range.startDate || !range.endDate) {
      return;
    }

    const jsStartDate = new Date(range.startDate); // Use different var names
    const jsEndDate = new Date(range.endDate);

    const startYear = jsStartDate.getFullYear();
    const startMonth = jsStartDate.getMonth() + 1;
    const startDay = jsStartDate.getDate();
    const endYear = jsEndDate.getFullYear();
    const endMonth = jsEndDate.getMonth() + 1;
    const endDay = jsEndDate.getDate();

    if (isMainIndex) {
      dispatch(setSelectedYearFrom(startYear));
      dispatch(setSelectedMonthFrom(startMonth));
      dispatch(setSelectedDayFrom(startDay));
      dispatch(setSelectedYearTo(endYear));
      dispatch(setSelectedMonthTo(endMonth));
      dispatch(setSelectedDayTo(endDay));
      // dispatch(setmainDateRangeInit(true)); // Indicate range is set
    } else if (index !== null) {
      dispatch(setAddedIndexesYearFrom({ index: index, yearFrom: startYear }));
      dispatch(setAddedIndexesmonthFrom({ index: index, monthFrom: startMonth }));
      dispatch(setAddedIndexesdayFrom({ index: index, dayFrom: startDay }));
      dispatch(setAddedIndexesYearTo({ index: index, yearTo: endYear }));
      dispatch(setAddedIndexesmonthTo({ index: index, monthTo: endMonth }));
      dispatch(setAddedIndexesdayTo({ index: index, dayTo: endDay }));
    }
  };

  const formatDisplayDateRange = (yF, mF, dF, yT, mT, dT) => {
    const hasValidDates = !isNaN(parseInt(yF)) && !isNaN(parseInt(mF)) && !isNaN(parseInt(dF)) &&
                        !isNaN(parseInt(yT)) && !isNaN(parseInt(mT)) && !isNaN(parseInt(dT));
    
    if (!hasValidDates) {
      return "Select Date Range";
    }

    const range = formatRangeForPicker(yF, mF, dF, yT, mT, dT)[0];
    const startDate = range.startDate;
    const endDate = range.endDate;

    if (startDate && endDate) {
        const startStr = startDate.toLocaleDateString();
        const endStr = endDate.toLocaleDateString();
        return startDate.getTime() === endDate.getTime() ? startStr : `${startStr} - ${endStr}`;
    }
    return "Select Date Range";
  };

  const handleMainPickerClick = (event) => {
    if (!mainIndex[0]) {
      return;
    }
    setMainPickerAnchorEl(event.currentTarget);
    setTouchedFields(prev => ({ ...prev, dateRange: true }));
  };

  const handleMainPickerClose = () => {
    setMainPickerAnchorEl(null);
  };

  const handleAddedPickerClick = (event, index) => {
    setAddedPickerAnchorEls(prev => ({
      ...prev,
      [index]: event.currentTarget
    }));
    setAddedTouchedFields(prev => ({
      ...prev,
      [index]: { ...prev[index], dateRange: true }
    }));
  };

  const handleAddedPickerClose = (index) => {
    setAddedPickerAnchorEls(prev => ({
      ...prev,
      [index]: null
    }));
  };

  // Get available date range for display
  const getAvailableDateRangeText = (indexName) => {
    const dateRange = getDateRange(indexName);
    if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      return `Available: ${dateRange[0].toLocaleDateString()} - ${dateRange[1].toLocaleDateString()}`;
    }
    return "";
  };

  useEffect(() => {
    const removeProperties = ({
      spatialStats,
      temporalStats,
      temporalMethod,
      periodOfTime,
      current_yearFrom,
      current_yearTo,
      current_monthFrom,
      current_monthTo,
      current_dayFrom,
      current_dayTo,
      ...rest
    }) => rest;

    const mainIndexData = {
      name: mainIndex.length > 0 ? mainIndex[0] : null,
      hist_yearFrom: currentAll && currentAll.length > 0 ? currentAll[0]?.hist_yearFrom : null,
      hist_yearTo: currentAll && currentAll.length > 0 ? currentAll[0]?.hist_yearTo : null,
    };

    const cleanedObjList = addIndexes.map((obj, index) => {
      const existingData = currentAll && currentAll.length > (index + 1) ? currentAll[index + 1] : null;
      return {
        ...removeProperties(obj),
        hist_yearFrom: existingData?.hist_yearFrom,
        hist_yearTo: existingData?.hist_yearTo
      };
    });

    let nextCurrentAll = [mainIndexData, ...cleanedObjList];

    if (JSON.stringify(nextCurrentAll) !== JSON.stringify(currentAll)) {
      const validEntries = nextCurrentAll.filter(item => item.name !== null);
      if (validEntries.length > 0 || (currentAll && currentAll.length > 0)) {
        dispatch(setCurrentAll(validEntries));
      }
    }
  }, [mainIndex, addIndexes, dispatch]);

  // Check if field should show error - Updated to match RefIndexComponent pattern
  const shouldShowError = (isValid) => {
    return showValidation && !isValid;
  };

  const shouldShowErrorForAdded = (isValid) => {
    return showValidation && !isValid;
  };

  return (
    <div className="hide-scrollbar-tracker">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingRight: "250px", paddingLeft: "250px" }}>
        <Typography fontSize={24} fontWeight={600} fontFamily={"monospace"}>
          Indices
        </Typography>
        <Typography style={{ paddingTop: "10px", paddingBottom: "15px" }} fontSize={12} fontWeight={300} fontFamily={"monospace"}>
          Note: First Index is the Main Index
        </Typography>
        <Autocomplete
          limitTags={2}
          size="medium"
          disablePortal
          id="combo-box-demo"
          isOptionEqualToValue={(option, value) => option.name === value.name}
          getOptionLabel={(option) => (option ? option.name : "")}
          onChange={(event, selected) => {
            const index = JSON.parse(localStorage.getItem("categories")).filter((category) => category.id === selected.id);
            dispatch(setMainIndex([selected.key]));
          }}
          options={indexes || []}
          sx={{ width: "40%", marginBottom: "50px" }}
          renderInput={(params) => <TextField {...params} label="Index" />}
        />
        <br />
        {mainIndex.map((main, index) => {
          // Updated validation checks - more explicit
          const hasDateRange = Boolean(
            typeof yearFrom === 'number' && 
            typeof monthFrom === 'number' && 
            typeof dayFrom === 'number' &&
            typeof yearTo === 'number' && 
            typeof monthTo === 'number' && 
            typeof dayTo === 'number'
          );
          const hasSpatialStats = Boolean(spatialStats[mainIndex[index]]);
          const hasTemporalStats = Boolean(temporalStats[mainIndex[index]]);
          const hasHistYearFrom = Boolean(currentAll && currentAll[0] && currentAll[0].hist_yearFrom);
          const hasHistYearTo = Boolean(currentAll && currentAll[0] && currentAll[0].hist_yearTo);

          return (
            <div key={index} className="pred-main-index-container" style={{ width: "100%" }}>
              <div className="pred-select-by-month-container">
                <div style={{ width: "100%" }}>
                  <Typography>Select Range *</Typography>
                  {mainIndex[0] && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginBottom: '8px' }}>
                      {getAvailableDateRangeText(mainIndex[0])}
                    </Typography>
                  )}
                  <TextField
                    label="Selected Date Range"
                    variant="outlined"
                    fullWidth
                    size="small"
                    margin="normal"
                    required
                    error={shouldShowError(hasDateRange)}
                    helperText={shouldShowError(hasDateRange) ? "This field is required" : ""}
                    sx={requiredFieldStyle}
                    aria-describedby={mainPickerId}
                    value={formatDisplayDateRange(yearFrom, monthFrom, dayFrom, yearTo, monthTo, dayTo)}
                    onClick={handleMainPickerClick}
                    disabled={!mainIndex[0]}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  {!mainIndex[0] && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '-8px' }}>
                      Please select an index first to enable date selection.
                    </Typography>
                  )}
                  <Popover
                    id={mainPickerId}
                    open={mainPickerOpen}
                    anchorEl={mainPickerAnchorEl}
                    onClose={handleMainPickerClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <DateRangePicker
                      staticRanges={[]}
                      ranges={formatRangeForPicker(yearFrom, monthFrom, dayFrom, yearTo, monthTo, dayTo, mainIndex[0])}
                      onChange={item => handleRangeChange(item, true)}
                      minDate={getDateRange(mainIndex[0])[0]}
                      maxDate={getDateRange(mainIndex[0])[1]}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      months={1}
                      direction="horizontal"
                      editableDateInputs={false}
                    />
                  </Popover>
                </div>
              </div>

              <div style={{ marginTop: "1em" }}>
                <InputLabel id={"spatial-stats-label" + index} required>
                  Spatial Stats
                </InputLabel>
                <Select
                  fullWidth
                  size="small"
                  required
                  error={shouldShowError(hasSpatialStats)}
                  labelId={"spatial-stats-label" + index}
                  id={"spatial-stats-select" + index}
                  value={spatialStats[mainIndex[index]] || ''}
                  onOpen={() => setTouchedFields(prev => ({ ...prev, spatialStats: true }))}
                  onChange={(event) => {
                    dispatch(
                      setSpatialStats({
                        index: index,
                        value: event.target.value,
                      })
                    );
                  }}
                >
                  {statsList.map((stat, statIndex) => {
                    return <MenuItem key={statIndex} value={stat.key}>{stat.name}</MenuItem>;
                  })}
                </Select>
                {shouldShowError(hasSpatialStats) && (
                  <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                    This field is required
                  </Typography>
                )}
              </div>
              <div style={{ marginTop: "1em" }}>
                <InputLabel id={"temporal-stats-label" + index} required>
                  Temporal Stats
                </InputLabel>
                <Select
                  fullWidth
                  size="small"
                  required
                  error={shouldShowError(hasTemporalStats)}
                  labelId={"temporal-stats-label" + index}
                  id={"temporal-stats-select" + index}
                  value={temporalStats[mainIndex[index]] || ''}
                  onOpen={() => setTouchedFields(prev => ({ ...prev, temporalStats: true }))}
                  onChange={(event) => {
                    dispatch(
                      setTemporalStats({
                        index: index,
                        value: event.target.value,
                      })
                    );
                  }}
                >
                  {statsList.map((stat, statIndex) => {
                    return <MenuItem key={statIndex} value={stat.key}>{stat.name}</MenuItem>;
                  })}
                </Select>
                {shouldShowError(hasTemporalStats) && (
                  <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                    This field is required
                  </Typography>
                )}
              </div>

              <div style={{ marginTop: "1em" }}>
                <CustomCheckBox
                  title={"Time-step"}
                  data={mainPeriodOfTime}
                  dispatch={dispatch}
                  reduxFunc={setMainPeriodOfTime}
                />
              </div>

              <CustomCheckBox
                title={"Temporal Method"}
                data={mainTemporalMethod}
                dispatch={dispatch}
                reduxFunc={setMainTemporalMethod}
              />

              {currentAll && currentAll.length > 0 && currentAll[0] && (
                <div style={{ width: "100%", marginTop: '20px' }}>
                  <Typography fontSize={16} fontWeight={600} fontFamily={"monospace"} textAlign={"left"}>
                    Historical Data Range *
                  </Typography>
                  <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "50px", marginTop: '10px' }}>
                    <div style={{ width: "100%" }}>
                      <Typography sx={{ marginTop: "10px" }}>From *</Typography>
                      <YearPickerPrediction
                        style={{ width: "100%" }}
                        addedIndex={0}
                        setYear={(value) => {
                          dispatch(setSelectedYearFromCurrent({
                            index: 0,
                            yearFrom: value
                          }));
                        }}
                        label="Select Year"
                        value={currentAll[0].hist_yearFrom}
                      />
                      {shouldShowError(hasHistYearFrom) && (
                        <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                          This field is required
                        </Typography>
                      )}
                    </div>
                    <div style={{ width: "100%" }}>
                      <Typography sx={{ marginTop: "10px" }}>To *</Typography>
                      <YearPickerPrediction
                        style={{ width: "100%" }}
                        addedIndex={0}
                        setYear={(value) => {
                          dispatch(setSelectedYearToCurrent({
                            index: 0,
                            yearTo: value
                          }));
                        }}
                        label="Select Year"
                        value={currentAll[0].hist_yearTo}
                      />
                      {shouldShowError(hasHistYearTo) && (
                        <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                          This field is required
                        </Typography>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div style={{ marginTop: "30px" }}>
                {addIndexes.length > 0 && (
                  <Divider sx={{ marginY: '40px', '&::before, &::after': { borderColor: 'rgba(0, 0, 0, 0.3)' } }}>
                    <Typography variant="overline" color="text.secondary">Additional Indexes</Typography>
                  </Divider>
                )}
                {addIndexes.map((added, addedIndex) => {
                  const hasAddedDateRange = Boolean(
                    typeof added.current_yearFrom === 'number' && 
                    typeof added.current_monthFrom === 'number' && 
                    typeof added.current_dayFrom === 'number' &&
                    typeof added.current_yearTo === 'number' && 
                    typeof added.current_monthTo === 'number' && 
                    typeof added.current_dayTo === 'number'
                  );
                  const hasAddedSpatialStats = Boolean(added.spatialStats);
                  const hasAddedTemporalStats = Boolean(added.temporalStats);
                  const hasAddedHistYearFrom = Boolean(currentAll && currentAll[addedIndex + 1] && currentAll[addedIndex + 1].hist_yearFrom);
                  const hasAddedHistYearTo = Boolean(currentAll && currentAll[addedIndex + 1] && currentAll[addedIndex + 1].hist_yearTo);
                  const hasAddedIndex = Boolean(added.name && added.id);

                  return (
                    <div key={addedIndex}>
                      {addedIndex > 0 && (
                        <Divider sx={{ marginY: '30px', '&::before, &::after': { borderColor: 'rgba(0, 0, 0, 0.2)' } }} />
                      )}
                      <Typography fontWeight={600}>Choose Index *</Typography>
                      <br />
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        isOptionEqualToValue={(option, value) =>
                          option.name === value.name
                        }
                        getOptionLabel={(option) => (option ? option.name : "")}
                        onChange={(event, selected) => {
                          dispatch(
                            setAddedIndexesName({
                              index: addedIndex,
                              name: selected.key,
                            })
                          );
                          dispatch(
                            setAddedIndexesId({
                              index: addedIndex,
                              id: selected.id,
                            })
                          );
                        }}
                        options={indexes || []}
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            label="Index"
                            required
                            error={shouldShowErrorForAdded(hasAddedIndex)}
                            helperText={shouldShowErrorForAdded(hasAddedIndex) ? "This field is required" : ""}
                          />
                        )}
                      />
                      <br />
                      <div>
                        <Typography>Select Range *</Typography>
                        {added.name && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginBottom: '8px' }}>
                            {getAvailableDateRangeText(added.name)}
                          </Typography>
                        )}
                        {(() => {
                          const addedPickerAnchorEl = addedPickerAnchorEls[addedIndex];
                          const addedPickerOpen = Boolean(addedPickerAnchorEl);
                          const addedPickerId = addedPickerOpen ? `added-daterange-popover-${addedIndex}` : undefined;
                          
                          return (
                            <>
                              <TextField
                                label="Selected Date Range"
                                variant="outlined"
                                fullWidth
                                size="small"
                                margin="normal"
                                required
                                error={shouldShowErrorForAdded(hasAddedDateRange)}
                                helperText={shouldShowErrorForAdded(hasAddedDateRange) ? "This field is required" : ""}
                                disabled={!added.name}
                                aria-describedby={addedPickerId}
                                value={formatDisplayDateRange(added.current_yearFrom, added.current_monthFrom, added.current_dayFrom, added.current_yearTo, added.current_monthTo, added.current_dayTo)}
                                onClick={(e) => handleAddedPickerClick(e, addedIndex)}
                                InputProps={{ readOnly: true }}
                              />
                              {!added.name && (
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginTop: '-8px' }}>
                                  Please select an index first to enable date selection.
                                </Typography>
                              )}
                              <Popover
                                id={addedPickerId}
                                open={addedPickerOpen}
                                anchorEl={addedPickerAnchorEl}
                                onClose={() => handleAddedPickerClose(addedIndex)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                              >
                                <DateRangePicker
                                  staticRanges={[]}
                                  ranges={formatRangeForPicker(added.current_yearFrom, added.current_monthFrom, added.current_dayFrom, added.current_yearTo, added.current_monthTo, added.current_dayTo, added.name)}
                                  onChange={item => handleRangeChange(item, false, addedIndex)}
                                  minDate={getDateRange(added.name)[0]}
                                  maxDate={getDateRange(added.name)[1]}
                                  showSelectionPreview={true}
                                  moveRangeOnFirstSelection={false}
                                  months={1}
                                  direction="horizontal"
                                  showDateDisplay={false}
                                  editableDateInputs={false}
                                />
                              </Popover>
                            </>
                          );
                        })()}
                      </div>
                      <br />
                      <div>
                        <InputLabel id={"added-spatial-stats-label" + addedIndex} required>
                          Spatial Stats
                        </InputLabel>
                        <Select
                          fullWidth
                          size="small"
                          required
                          error={shouldShowErrorForAdded(hasAddedSpatialStats)}
                          labelId={"added-spatial-stats-label" + addedIndex}
                          id={"added-spatial-stats-select" + addedIndex}
                          value={added.spatialStats || spatialStats[mainIndex[addedIndex]] || ''}
                          onChange={(event) => {
                            dispatch(
                              setAddedIndexesSpatialStat({
                                index: addedIndex,
                                stat: event.target.value,
                              })
                            );
                          }}
                        >
                          {statsList.map((stat, statIndex) => {
                            return (
                              <MenuItem key={statIndex} value={stat.key}>{stat.name}</MenuItem>
                            );
                          })}
                        </Select>
                        {shouldShowErrorForAdded(hasAddedSpatialStats) && (
                          <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                            This field is required
                          </Typography>
                        )}
                      </div>
                      <br />
                      <div>
                        <InputLabel id={"added-temporal-stats-label" + addedIndex} required>
                          Temporal Stats
                        </InputLabel>
                        <Select
                          fullWidth
                          size="small"
                          required
                          error={shouldShowErrorForAdded(hasAddedTemporalStats)}
                          labelId={"added-temporal-stats-label" + addedIndex}
                          id={"added-temporal-stats-select" + addedIndex}
                          value={added.temporalStats || temporalStats[mainIndex[addedIndex]] || ''}
                          onChange={(event) => {
                            dispatch(
                              setAddedIndexesTempStat({
                                index: addedIndex,
                                stat: event.target.value,
                              })
                            );
                          }}
                        >
                          {statsList.map((stat, statIndex) => {
                            return (
                              <MenuItem key={statIndex} value={stat.key}>{stat.name}</MenuItem>
                            );
                          })}
                        </Select>
                        {shouldShowErrorForAdded(hasAddedTemporalStats) && (
                          <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                            This field is required
                          </Typography>
                        )}
                      </div>
                      <br />
                      <div>
                        <CustomCheckBox
                          title={"Time-step"}
                          data={added.periodOfTime}
                          dispatch={dispatch}
                          reduxFunc={setAddedIndexesPeriodOfTime}
                          index={addedIndex}
                        />
                      </div>
                      <br />
                      <CustomCheckBox
                        title={"Temporal Method"}
                        data={added.temporalMethod}
                        dispatch={dispatch}
                        reduxFunc={setAddedIndexesTemporalMethod}
                        index={addedIndex}
                      />

                      {currentAll && currentAll.length > addedIndex + 1 && currentAll[addedIndex + 1] && (
                        <div style={{ width: "100%", marginTop: '20px' }}>
                          <Typography fontSize={16} fontWeight={600} fontFamily={"monospace"} textAlign={"left"}>
                            Historical Data Range *
                          </Typography>
                          <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "50px", marginTop: '10px' }}>
                            <div style={{ width: "100%" }}>
                              <Typography sx={{ marginTop: "10px" }}>From *</Typography>
                              <YearPickerPrediction
                                style={{ width: "100%" }}
                                addedIndex={addedIndex + 1}
                                setYear={(value) =>
                                  dispatch(setSelectedYearFromCurrent({
                                    index: addedIndex + 1,
                                    yearFrom: value
                                  }))
                                }
                                label="Select Year"
                                defaultValue={currentAll[addedIndex + 1].hist_yearFrom || defHistYearFrom}
                              />
                              {shouldShowErrorForAdded(hasAddedHistYearFrom) && (
                                <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                                  This field is required
                                </Typography>
                              )}
                            </div>
                            <div style={{ width: "100%" }}>
                              <Typography sx={{ marginTop: "10px" }}>To *</Typography>
                              <YearPickerPrediction
                                style={{ width: "100%" }}
                                addedIndex={addedIndex + 1}
                                setYear={(value) =>
                                  dispatch(setSelectedYearToCurrent({
                                    index: addedIndex + 1,
                                    yearTo: value
                                  }))
                                }
                                label="Select Year"
                                defaultValue={currentAll[addedIndex + 1].hist_yearTo || defHistYearTo}
                              />
                              {shouldShowErrorForAdded(hasAddedHistYearTo) && (
                                <Typography variant="caption" color="error" sx={{ display: 'block', marginTop: '4px' }}>
                                  This field is required
                                </Typography>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <br />
                      <br />

                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          dispatch(deleteOneAddIndex({ index: addedIndex }));
                        }}
                      >
                        Delete this index
                      </Button>
                      <br />
                      <br />
                    </div>
                  );
                })}
              </div>
              <Button onClick={handleAddIndex} style={{ fontSize: "20px" }}>Add index</Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MainIndex;